import api from './api';

export const uploadSurveyMainImage = async (files, id) => {
  try {
    const response = await api.post(
      `/files/uploadSurveyMainImage/${id}`,
      files,
      {
        headers: {
          'Content-Type': 'multipart/form-data' // Cambia el Content-Type para archivos
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      'Error en el inicio de sesión:',
      error.response?.data || error.message
    );
    throw error.response?.data || error;
  }
};

export const deleteSurveyImage = async survey_id => {
  try {
    const response = await api.delete(`/files/deleteSurveyImage/${survey_id}`);
    return response.data;
  } catch (error) {
    console.error(
      'Error al obtener los grupos de preguntas:',
      error.response?.data || error.message
    );
    return { result: false };
  }
};

export const uploadSiteLogo = async (files, id) => {
  try {
    const response = await api.post(`/files/uploadSiteLogo/${id}`, files, {
      headers: {
        'Content-Type': 'multipart/form-data' // Cambia el Content-Type para archivos
      }
    });
    return response.data;
  } catch (error) {
    console.error(
      'Error en el inicio de sesión:',
      error.response?.data || error.message
    );
    throw error.response?.data || error;
  }
};

export const deleteSiteLogo = async site_id => {
  try {
    const response = await api.delete(`/files/deleteSiteLogo/${site_id}`);
    return response.data;
  } catch (error) {
    console.error(
      'Error al obtener los grupos de preguntas:',
      error.response?.data || error.message
    );
    return { result: false };
  }
};
